<ngx-skeleton-loader [count]="count" />